module.exports = __webpack_public_path__ + "static/media/autometrics-ashok-leyland.ab639668.png";